import {emotionStyled} from '@packages/utilities/styled';
import {FormGroup, FormLabel, TextInput} from '@packages/systems/spring';
import {brandedFontFamily} from '../../constants';

export const BrandedFormGroup = emotionStyled(FormGroup)({
  'label, label span': {
    color: '$textSecondary',
  },
  [`${FormLabel}, ${TextInput}`]: {
    fontFamily: brandedFontFamily,
    fontSize: '$brandedBody',
    lineHeight: '$brandedBody',
  },
  '[data-sc="TextInput"]': {
    padding: '$2',
  },
});

BrandedFormGroup.displayName = 'BrandedFormGroup';

export default BrandedFormGroup;
